<p>ng-form-input-number works!</p>
